import React, { useState, useEffect } from "react";
import { Filter, MoreVertical } from "lucide-react";
import { ADGetTickets } from "../Services/AllTicketsService";
import ADApproveTicketModal from "../Modals/ADApproveTicketModal";
import ADRejectTicketModal from "../Modals/ADRejectTicketModal";
import ADAssignTicketModal from "../Modals/ADAssignTicketModal";
import ADInProgressTicketModal from "../Modals/ADInProgressTicketModal";
import ADReadyForReviewTicketModal from "../Modals/ADReadyForReviewTicketModal";
import ADAssignToReviewerTicketModal from "../Modals/ADAssignToReviewerTicketModal";
import ADReviewInProgressTicketModal from "../Modals/ADReviewInProgressTicketModal";
import ADReviewedTicketModal from "../Modals/ADReviewedTicketModal";
import ADReopenTicketModal from "../Modals/ADReopenTicketModal";
import ADClosedTicketModal from "../Modals/ADClosedTicketModal";
import ADHoldTicketModal from "../Modals/ADHoldTicketModal";
import ADResumeTicketModal from "../Modals/ADResumeTicketModal";
import ViewTicketModal from "../../../../Modal/ViewTicketModal";
import CreateTicketModal from "../../../../Modal/CreateTicketModal";
import NotificationAlert from "../../../../Alerts/NotificationAlert";
import DropdownPortal from "../../../../DropDownPortal";
import TicketHistoryModal from "../../../../Modal/TicketHistoryModal";
import FilterTableModal from "../../../../Modal/FilterTableModal";
import { useNavigate } from "react-router-dom";
import TableHeader from "../../../../Common/TableHeader";
import Pagination from "../../../../Common/Pagination";
import { globalSearch } from "../../../../Utils/globalSearch";

const getSeverityStyle = (severity) => {
  switch (severity) {
    case "High":
      return "bg-red-100 text-red-700";
    case "Moderate":
      return "bg-yellow-100 text-yellow-700";
    case "Low":
      return "bg-green-100 text-green-700";
    default:
      return "bg-gray-100 text-gray-600";
  }
};

const ADAllTickets = () => {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  // Approve Tickets States
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveTicketData, setApproveTicketData] = useState(null);

  // Reject Tickets States
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectTicketData, setRejectTicketData] = useState(null);

  // Assign Tickets States
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignTicketData, setAssignTicketData] = useState(null);

  // In-Progress Tickets States
  const [showInProgressModal, setShowInProgressModal] = useState(false);
  const [inProgressTicketData, setInProgressTicketData] = useState(null);

  // Ready for Review Tickets States
  const [showReadyForReviewModal, setShowReadyForReviewModal] = useState(false);
  const [readyForReviewTicketData, setReadyForReviewTicketData] =
    useState(null);

  // Assign To Reviewer Tickets States
  const [showAssignToReviewerModal, setShowAssignToReviewerModal] =
    useState(false);
  const [assignToReviewerTicketData, setAssignToReviewerTicketData] =
    useState(null);

  // Review in Progress Tickets States
  const [showReviewInProgressModal, setShowReviewInProgressModal] =
    useState(false);
  const [reviewInProgressTicketData, setReviewInProgressTicketData] =
    useState(null);

  // Reviewed Tickets States
  const [showReviewedModal, setShowReviewedModal] = useState(false);
  const [reviewedTicketData, setReviewedTicketData] = useState(null);

  // Reopen Tickets States
  const [showReopenModal, setShowReopenModal] = useState(false);
  const [reopenTicketData, setReopenTicketData] = useState(null);

  // Closed Tickets States
  const [showClosedModal, setShowClosedModal] = useState(false);
  const [closedTicketData, setClosedTicketData] = useState(null);

  // Hold Tickets States
  const [showHoldModal, setShowHoldModal] = useState(false);
  const [holdTicketData, setHoldTicketData] = useState(null);

  // Resume Tickets States
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [resumeTicketData, setResumeTicketData] = useState(null);

  const [historyModal, setHistoryModal] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  // filtering states
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [columnFilters, setColumnFilters] = useState({
    "Project Name": [],
    "Ticket Type": [],
    "Assigned To": [],
    Status: [],
    Priority: [],
  });

  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterModalField, setFilterModalField] = useState("");
  const [filterModalOptions, setFilterModalOptions] = useState([]);

  // Search States
  const [searchQuery, setSearchQuery] = useState("");

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [errors, setErrors] = useState({});

  //load Tickets
  useEffect(() => {
    loadTickets(0);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, columnFilters, filteredTickets, rowsPerPage]);

  const loadTickets = async () => {
    try {
      const response = await ADGetTickets(0);
      const data = response.data;

      if (data.status === "Success") {
        const formatted = data.tickets.map((t, index) => ({
          id: index + 1,
          title: t.title,
          description: t.description,
          severity: t.severity,
          severityByPM: t.severityByPM,
          ticketType: t.ticketType,
          status: t.status,
          ticketNumber: t.ticketNumber,
          ticketUID: t.ticketUID,
          projectName: t.projectName,
          projectUID: t.projectUID,
          raisedByEmail: t.raisedByEmail,
          assignedBy: t.assignedBy,
          assignedTo: t.assignedTo,
          raisedAt: t.raisedAt,
          updated: formatDateTime(t.updatedAt),
          approvedAt: t.approvedAt,
          estimatedCompleteByDev: t.estimatedCompleteByDev,
          closeDate: t.closeDate,
          attachmentUrls: t.attachmentUrls || [],
          ...t,
          // updated: new Date(t.raisedAt).toLocaleDateString(),
        }));

        setTickets(formatted);
        setFilteredTickets(formatted);
      }
    } catch (err) {
      if (err.response?.status === 400) {
        navigate("/bad-request", {
          state: {
            error: err.response?.data?.message || "Bad request (400)",
          },
        });
        return;
      }
      console.error("Error fetching tickets:", err);
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, Mar...
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // convert 0 → 12

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };

  // Close menu when clicking outside
  useEffect(() => {
    const closeMenu = () => setOpenActionMenu(null);
    window.addEventListener("click", closeMenu);
    return () => window.removeEventListener("click", closeMenu);
  }, []);

  // Filters Function
  const getUniqueOptionsForField = (field) => {
    const map = {
      "Project Name": "projectName",
      "Ticket Type": "ticketType",
      "Assigned To": "assignedTo",
      Status: "status",
      Priority: "severity",
    };

    const prop = map[field];
    if (!prop) return [];

    const set = new Set();
    tickets.forEach((t) => {
      const val = t[prop] ?? "--";
      set.add(val);
    });

    return Array.from(set).sort((a, b) => {
      if (a === "--") return 1;
      if (b === "--") return -1;
      return String(a).localeCompare(String(b));
    });
  };

  const openFilterFor = (field) => {
    const opts = getUniqueOptionsForField(field);
    setFilterModalOptions(opts);
    setFilterModalField(field);
    setFilterModalOpen(true);
  };

  const applyColumnFilter = (field, selections) => {
    setColumnFilters((prev) => ({ ...prev, [field]: selections }));
    const newFilters = { ...columnFilters, [field]: selections };

    let result = tickets;

    // Apply all column filters
    Object.entries(newFilters).forEach(([f, values]) => {
      if (!values || values.length === 0) return;

      const map = {
        "Project Name": "projectName",
        "Ticket Type": "ticketType",
        "Assigned To": "assignedTo",
        Status: "status",
        Priority: "severity",
      };

      const prop = map[f];
      result = result.filter((t) => values.includes(t[prop] ?? "--"));
    });

    // Apply search after column filters
    if (searchQuery.trim() !== "") {
      result = result.filter((t) =>
        Object.values({
          title: t.title,
          description: t.description,
          projectName: t.projectName,
          severity: t.severity,
          ticketType: t.ticketType,
          assignedTo: t.assignedTo,
          status: t.status,
        })
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase()),
      );
    }

    setFilteredTickets(result);
  };

  const clearAllFilters = () => {
    setColumnFilters({
      "Project Name": [],
      "Ticket Type": [],
      "Assigned To": [],
      Status: [],
      Priority: [],
    });
    setFilteredTickets(tickets);
  };

  let baseData =
    searchQuery.trim() !== "" ||
    Object.values(columnFilters).some((arr) => arr.length > 0)
      ? filteredTickets
      : tickets;
  const rowsToShow = baseData;

  // Search Function
  const handleSearch = (query) => {
  setSearchQuery(query);
  setFilteredTickets(globalSearch(tickets, query));
};

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const currentRows = rowsToShow.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(rowsToShow.length / rowsPerPage);

  const startIndex = rowsToShow.length === 0 ? 0 : indexOfFirstRow + 1;
  const endIndex = Math.min(indexOfLastRow, rowsToShow.length);

  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/*  Header Section */}
        <TableHeader
          searchQuery={searchQuery}
          onSearch={handleSearch}
          onCreate={() => setShowModal(true)}
          placeholder="Search for tickets"
          createLabel="+ Create Ticket"
          totalRecords={rowsToShow.length}
          startIndex={startIndex}
          endIndex={endIndex}
          rowsPerPage={rowsPerPage}
          onPageSizeChange={setRowsPerPage}
        />

        {/*  Table Section */}
        <div className="overflow-x-auto overflow-visible bg-white rounded-lg shadow-sm border border-gray-200">
          <table className="w-full text-sm text-left text-gray-700">
            <thead className="bg-gray-100 text-gray-600 uppercase text-xs font-semibold">
              <tr>
                <th className="p-3">Ticket No.</th>
                <th className="p-3">
                  <div className="flex items-center gap-2">
                    <span>Project Name</span>
                    <button
                      onClick={() => openFilterFor("Project Name")}
                      className="p-1 rounded hover:bg-gray-100"
                      title="Filter Project Name"
                    >
                      <Filter size={14} />
                    </button>
                    {columnFilters["Project Name"]?.length > 0 && (
                      <span className="ml-1 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                        {columnFilters["Project Name"].length}
                      </span>
                    )}
                  </div>
                </th>

                <th className="p-3">
                  <div className="flex items-center gap-2">
                    <span>Ticket Type</span>
                    <button
                      onClick={() => openFilterFor("Ticket Type")}
                      className="p-1 rounded hover:bg-gray-100"
                      title="Filter Ticket Type"
                    >
                      <Filter size={14} />
                    </button>
                    {columnFilters["Ticket Type"]?.length > 0 && (
                      <span className="ml-1 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                        {columnFilters["Ticket Type"].length}
                      </span>
                    )}
                  </div>
                </th>

                <th className="p-3">
                  <div className="flex items-center gap-2">
                    <span>Assigned To</span>
                    <button
                      onClick={() => openFilterFor("Assigned To")}
                      className="p-1 rounded hover:bg-gray-100"
                      title="Filter Assigned To"
                    >
                      <Filter size={14} />
                    </button>
                    {columnFilters["Assigned To"]?.length > 0 && (
                      <span className="ml-1 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                        {columnFilters["Assigned To"].length}
                      </span>
                    )}
                  </div>
                </th>

                <th className="p-3">
                  <div className="flex items-center gap-2">
                    <span>Status</span>
                    <button
                      onClick={() => openFilterFor("Status")}
                      className="p-1 rounded hover:bg-gray-100"
                      title="Filter Status"
                    >
                      <Filter size={14} />
                    </button>
                    {columnFilters["Status"]?.length > 0 && (
                      <span className="ml-1 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                        {columnFilters["Status"].length}
                      </span>
                    )}
                  </div>
                </th>

                <th className="p-3">
                  <div className="flex items-center gap-2">
                    <span>Priority</span>
                    <button
                      onClick={() => openFilterFor("Priority")}
                      className="p-1 rounded hover:bg-gray-100"
                      title="Filter Priority"
                    >
                      <Filter size={14} />
                    </button>
                    {columnFilters["Priority"]?.length > 0 && (
                      <span className="ml-1 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                        {columnFilters["Priority"].length}
                      </span>
                    )}
                  </div>
                </th>

                <th className="p-3">Action</th>
              </tr>
            </thead>

            <tbody>
              {currentRows.length === 0 ? (
                <tr>
                  <td colSpan="7" className="p-6 text-center text-gray-500">
                    No tickets found.
                  </td>
                </tr>
              ) : (
                currentRows.map((ticket) => (
                  <tr
                    key={ticket.ticketNumber}
                    className="border-b hover:bg-gray-50 transition-colors"
                  >
                    <td
                      className="p-3 font-medium text-blue-600 cursor-pointer hover:underline"
                      onClick={() => {
                        setSelectedTicket(ticket);
                        setViewModal(true);
                      }}
                    >
                      {ticket.ticketNumber}
                    </td>
                    {/* <td
                    className="p-3 font-medium text-blue-600 cursor-pointer hover:underline max-w-[180px] truncate"
                    onClick={() => {
                      setSelectedTicket(ticket);
                      setViewModal(true);
                    }}
                  >
                    {ticket.title}
                  </td> */}
                    <td className="p-3">{ticket.projectName}</td>
                    {/* <td className="p-3">{ticket.updated}</td> */}
                    <td className="p-3">{ticket.ticketType}</td>
                    <td className="p-3">{ticket.assignedTo || "--"}</td>
                    <td className="p-3">{ticket.status}</td>
                    <td className="p-3">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium ${getSeverityStyle(
                          ticket.severity,
                        )}`}
                      >
                        {ticket.severity}
                      </span>
                    </td>
                    {/* ACTION BUTTON */}
                    <td className="p-3">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenActionMenu(
                            openActionMenu === ticket.id ? null : ticket.id,
                          );
                          setMenuPosition({ x: e.clientX, y: e.clientY });
                        }}
                        className="p-2 hover:bg-gray-100 rounded-full"
                      >
                        <MoreVertical size={18} />
                      </button>
                    </td>
                    {/* PORTAL DROPDOWN */}
                    {openActionMenu === ticket.id && (
                      <DropdownPortal>
                        <div
                          style={{
                            position: "fixed",
                            top: menuPosition.y + 10,
                            left: menuPosition.x - 160,
                            zIndex: 99999,
                          }}
                          className="w-44 bg-white border rounded-lg shadow-xl py-1"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {/* if Status is New */}
                          {ticket.status === "New" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setApproveTicketData(ticket);
                                  setShowApproveModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Approve
                              </button>

                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setRejectTicketData(ticket);
                                  setShowRejectModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Reject
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setAssignTicketData(ticket);
                                  setShowAssignModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Assign
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is Approved */}
                          {ticket.status === "Approved" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setAssignTicketData(ticket);
                                  setShowAssignModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Assign
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setRejectTicketData(ticket);
                                  setShowRejectModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Reject
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is Assigned */}
                          {ticket.status === "Assigned" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setInProgressTicketData(ticket);
                                  setShowInProgressModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                In-Progress
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is InProgress */}
                          {ticket.status === "In Progress" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setReadyForReviewTicketData(ticket);
                                  setShowReadyForReviewModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Ready For Review
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is Ready for Review */}
                          {ticket.status === "Ready For Review" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setAssignToReviewerTicketData(ticket);
                                  setShowAssignToReviewerModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Assign To Reviewer
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is Assign to Reviewer*/}
                          {ticket.status === "Assign To Reviewer" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setReviewInProgressTicketData(ticket);
                                  setShowReviewInProgressModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Review In Progress
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is Review In Progress*/}
                          {ticket.status === "Review In Progress" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setReviewedTicketData(ticket);
                                  setShowReviewedModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Reviewed
                              </button>

                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setReopenTicketData(ticket);
                                  setShowReopenModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Re-open
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is Reviewed*/}
                          {ticket.status === "Reviewed" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setClosedTicketData(ticket);
                                  setShowClosedModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Closed
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is Reopen*/}
                          {ticket.status === "Re-open" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setInProgressTicketData(ticket);
                                  setShowInProgressModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                In-progress
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setHoldTicketData(ticket);
                                  setShowHoldModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Hold
                              </button>
                            </>
                          )}
                          {/* if Status is Hold*/}
                          {ticket.status === "Hold" && (
                            <>
                              <button
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                onClick={() => {
                                  setResumeTicketData(ticket);
                                  setShowResumeModal(true);
                                  setOpenActionMenu(null);
                                }}
                              >
                                Resume
                              </button>
                            </>
                          )}
                        </div>
                      </DropdownPortal>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />

        <CreateTicketModal
          show={showModal}
          onClose={() => setShowModal(false)}
          onCreated={() => loadTickets()}
        />

        <FilterTableModal
          show={filterModalOpen}
          onClose={() => setFilterModalOpen(false)}
          field={filterModalField}
          options={filterModalOptions}
          activeSelections={columnFilters[filterModalField] || []}
          onApply={applyColumnFilter}
          onResetAll={clearAllFilters}
        />

        {/* View Details of Ticket Modal */}
        <ViewTicketModal
          show={viewModal}
          onClose={() => setViewModal(false)}
          onOpenHistory={(history) => {
            setViewModal(false);
            setHistoryData(history);
            setHistoryModal(true);
          }}
          ticket={selectedTicket}
          onApprove={(ticket) => {
            setApproveTicketData(ticket);
            setShowApproveModal(true);
          }}
          onReject={(ticket) => {
            setRejectTicketData(ticket);
            setShowRejectModal(true);
          }}
          onAssign={(ticket) => {
            setAssignTicketData(ticket);
            setShowAssignModal(true);
          }}
          onHold={(ticket) => {
            setHoldTicketData(ticket);
            setShowHoldModal(true);
          }}
          onInProgress={(ticket) => {
            setInProgressTicketData(ticket);
            setShowInProgressModal(true);
          }}
          onReadyForReview={(ticket) => {
            setReadyForReviewTicketData(ticket);
            setShowReadyForReviewModal(true);
          }}
          onAssignToReviewer={(ticket) => {
            setAssignToReviewerTicketData(ticket);
            setShowAssignToReviewerModal(true);
          }}
          onReviewInProgress={(ticket) => {
            setReviewInProgressTicketData(ticket);
            setShowReviewInProgressModal(true);
          }}
          onReviewed={(ticket) => {
            setReviewedTicketData(ticket);
            setShowReviewedModal(true);
          }}
          onReopen={(ticket) => {
            setReopenTicketData(ticket);
            setShowReopenModal(true);
          }}
          onClosed={(ticket) => {
            setClosedTicketData(ticket);
            setShowClosedModal(true);
          }}
          onResume={(ticket) => {
            setResumeTicketData(ticket);
            setShowResumeModal(true);
          }}
        />

        <TicketHistoryModal
          show={historyModal}
          onClose={() => {
            setHistoryModal(false);
            setViewModal(true);
          }}
          history={historyData}
        />

        <ADApproveTicketModal
          show={showApproveModal}
          onClose={() => setShowApproveModal(false)}
          ticketData={approveTicketData}
          onApproved={loadTickets}
        />

        <ADRejectTicketModal
          show={showRejectModal}
          onClose={() => setShowRejectModal(false)}
          ticketData={rejectTicketData}
          onRejected={loadTickets}
        />

        <ADAssignTicketModal
          show={showAssignModal}
          onClose={() => setShowAssignModal(false)}
          ticketData={assignTicketData}
          onAssigned={loadTickets}
        />

        <ADInProgressTicketModal
          show={showInProgressModal}
          onClose={() => setShowInProgressModal(false)}
          ticketData={inProgressTicketData}
          onInProgressed={loadTickets}
        />

        <ADReadyForReviewTicketModal
          show={showReadyForReviewModal}
          onClose={() => setShowReadyForReviewModal(false)}
          ticketData={readyForReviewTicketData}
          onReadyForReview={loadTickets}
        />

        <ADAssignToReviewerTicketModal
          show={showAssignToReviewerModal}
          onClose={() => setShowAssignToReviewerModal(false)}
          ticketData={assignToReviewerTicketData}
          onAssignToReviewer={loadTickets}
        />

        <ADReviewInProgressTicketModal
          show={showReviewInProgressModal}
          onClose={() => setShowReviewInProgressModal(false)}
          ticketData={reviewInProgressTicketData}
          onReviewInProgress={loadTickets}
        />

        <ADReviewedTicketModal
          show={showReviewedModal}
          onClose={() => setShowReviewedModal(false)}
          ticketData={reviewedTicketData}
          onReviewed={loadTickets}
        />

        <ADReopenTicketModal
          show={showReopenModal}
          onClose={() => setShowReopenModal(false)}
          ticketData={reopenTicketData}
          onReopened={loadTickets}
        />

        <ADClosedTicketModal
          show={showClosedModal}
          onClose={() => setShowClosedModal(false)}
          ticketData={closedTicketData}
          onClosed={loadTickets}
        />

        <ADHoldTicketModal
          show={showHoldModal}
          onClose={() => setShowHoldModal(false)}
          ticketData={holdTicketData}
          onHold={loadTickets}
        />

        <ADResumeTicketModal
          show={showResumeModal}
          onClose={() => setShowResumeModal(false)}
          ticketData={resumeTicketData}
          onResume={loadTickets}
        />
      </div>
      {/*  Notification Alert */}
      {alert && (
        <NotificationAlert
          type={alert.type}
          message={alert.message}
          show={true}
          duration={4000}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default ADAllTickets;
